import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const TreasureHuntPage = lazy(() => import('../../pages/TreasureHunt/TreasureHuntPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<TreasureHuntPage />} />
    </Routes>
  );
}

export default PagesRoute;
